export default __webpack_public_path__ + "static/media/red_pawn.955efe1c.png";